import { HeronDataUploadStatus } from '@40seas/entities/heron';
import { EnumColor } from '@40seas/frontend/common/providers';

export const heronDataUploadStatusColorMapping = {
    [HeronDataUploadStatus.Succeeded]: 'success',
    [HeronDataUploadStatus.Failed]: 'error',
} as { [key in HeronDataUploadStatus]: EnumColor };
